export const getContractPath = (
    streamCode: string,
    contractId: string,
    versionId: string
) => `/stream/${streamCode}/contract/${contractId}/version/${versionId}`;
